import { Colors } from "Components/Layout/Themes/Colors";
import { SettlementStatus } from "Infrastructure/Api/Api";
import { formatDate } from "Utils/DateUtils";

export type SettlementStatusInfo = {
  label: string;
  color: "success" | "warning" | "error";
  backgroundColor: string;
};

export const PAYMENT_STATUS_TO_INFO: Record<
  SettlementStatus,
  SettlementStatusInfo
> = {
  [SettlementStatus.Paid]: {
    label: "Zaplaceno",
    color: "success",
    backgroundColor: Colors.Green,
  },
  [SettlementStatus.Unpaid]: {
    label: "Čeká na zaplacení",
    color: "warning",
    backgroundColor: Colors.Warning,
  },
  [SettlementStatus.Overdue]: {
    label: "Po splatnosti",
    color: "error",
    backgroundColor: Colors.Red,
  },
};

export const formatPeriod = (
  currentDate?: string | null,
  previousDate?: string | null,
): string => {
  if (!currentDate) return "Aktuální období";

  // Pass the raw "yyyy-MM-dd" strings so formatDate can render them as UTC dates
  // (wrapping in new Date() here would reintroduce the local-zone day shift).
  const current = formatDate(currentDate);

  if (!previousDate) {
    return current;
  }

  const previous = formatDate(previousDate);
  return `${previous} - ${current}`;
};

export const formatPeriodMonth = (
  recordSettlementDate?: string | null,
): string | undefined => {
  if (!recordSettlementDate) {
    return undefined;
  }
  const date = new Date(recordSettlementDate);
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}`;
};
